import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { LoadingService } from './loading-service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
@Component({
  selector: 'srp-loading',
  imports: [MatProgressSpinner],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Loading {
  loading: boolean = false;
  constructor(private readonly cd: ChangeDetectorRef, private readonly loadingService: LoadingService) { }

  ngOnInit() {
     this.loadingService.loading$.subscribe((loading) => {
      this.loading = loading;
      this.cd.detectChanges();
    });



  }

}
